export default __webpack_public_path__ + "static/media/s4.b0c18f12.jpg";